import { render, staticRenderFns } from "./hairlist.vue?vue&type=template&id=6da0f06a&"
import script from "./hairlist.vue?vue&type=script&lang=js&"
export * from "./hairlist.vue?vue&type=script&lang=js&"
import style0 from "./hairlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports